import { Button } from "antd";
import Colors from "assets/Colors";
import styled from "styled-components";


const Container = styled.div`
  display: flex;
  width: 97%;
  flex-direction: column;
  margin: auto auto;
  margin-top: 10px;
  background: ${Colors.background_secondary};
  padding: 19px 18px 19px 19px;
  max-width: 100vw;
  box-shadow: 0px 6px 24px rgba(0, 0, 0, 0.06);
  border-radius: 5px;
  margin-bottom: 30px;
  @media (max-width: 768px) {
    display: block;
    width: 97%;
    margin: 0 auto;
    margin-bottom: 36px;
  }
`;

const containerHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

const buttonsHeader = styled.div`
  gap: 10px;
  display: flex;
`;

const button = styled(Button)`
  background: ${ (props) => props.background} !important;
  color: ${ (props) => props.background ? Colors.text_on_primary : Colors.text_primary} !important;
  width: none;
  font-size: 12px;
  border: 1px solid ${Colors.background_dividers} !important;
  border-radius: 2px;
  height: 34px;
  min-width: 80px;
  max-width: 100px;
  &:hover {
    background: ${ (props) => props.background && Colors.primary};
    color: ${ (props) => props.background ? Colors.text_on_primary : Colors.primary};
    border: 1px solid ${Colors.background_dividers};
  }
  &:disabled {
    // background: ${ (props) => props.background} !important;
    opacity: 0.5;
  }
`;

const containerBar = styled.div`
  display: flex;
  background: ${Colors.background_soft};
`;

const barCompleted = styled.div`
  background: ${Colors.primary};
  width: ${(props) => `${props.width}%`};
  height: 25px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

const barRemaining = styled.div`
    background: ${Colors.GREY};
    width: ${(props) => `${props.width}%`};
    height: 25px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
`

const containerHeaderText = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 10px;
  gap: 80px;
  margin-bottom: 5px;
  @media (max-width: 768px) {
    flex-direction: column;
    align-items: start;
    gap: 0;
  }
`;

const circleHeaderText = styled.div`
  height: 10px;
  width: 10px;
  border-radius: 5px;
  background-color: ${(props) => props.background};
`;

const text = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 6px;
`;

const title = styled.div`
  font-size: 20px;
  font-weight: 500;
  line-height: normal;
  letter-spacing: 0.2px;
`;


export default {
  Container,
  containerHeader,
  buttonsHeader,
  button,
  containerBar,
barCompleted,
barRemaining,
  containerHeaderText,
  circleHeaderText,
  text,
  title
};
